// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-menu-wrapper {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
}

.chat-menu-btn {
    background: transparent;
    border: none;
    color: #333;
    font-size: 18px;
    line-height: 1;
    width: 30px;
    height: 30px;
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;
}

.chat-menu-btn:hover {
    background: rgba(0,0,0,0.08);
    color: #000;
}

.chat-dropdown {
    position: absolute;
    right: 0;
    bottom: 28px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    min-width: 150px;
    z-index: 11;
    overflow: hidden;
}

.chat-dropdown > button {
    display: block;
    width: 100%;
    padding: 10px 16px;
    background: transparent;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background 0.15s;
}

.chat-dropdown > button:hover {
    background: #f5f5f5;
}

.chat-dropdown-confirm {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
}

.chat-dropdown-confirm span {
    color: #333;
    white-space: nowrap;
}

.chat-dropdown-confirm button {
    padding: 4px 10px;
    border-radius: 4px;
    border: 1px solid #ddd;
    cursor: pointer;
    font-size: 13px;
    background: #fff;
    transition: background 0.15s;
}

.chat-dropdown-confirm button:first-of-type {
    background: #dc3545;
    color: #fff;
    border-color: #dc3545;
}

.chat-dropdown-confirm button:first-of-type:hover {
    background: #bb2d3b;
}

.chat-dropdown-confirm button:last-of-type:hover {
    background: #f0f0f0;
}

/* Override per la navbar interna alla chat */
.navbar_chat_mobile .nameHeader {
    position: relative;
}

.navbar_chat_mobile .chat-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    margin-left: unset;
}

.navbar_chat_mobile .chat-dropdown {
    position: absolute;
    bottom: unset;
    top: 36px;
    right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components_css/chat_menu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,QAAQ;AACZ","sourcesContent":[".chat-menu-wrapper {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 100;\n}\n\n.chat-menu-btn {\n    background: transparent;\n    border: none;\n    color: #333;\n    font-size: 18px;\n    line-height: 1;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s, color 0.15s;\n}\n\n.chat-menu-btn:hover {\n    background: rgba(0,0,0,0.08);\n    color: #000;\n}\n\n.chat-dropdown {\n    position: absolute;\n    right: 0;\n    bottom: 28px;\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n    min-width: 150px;\n    z-index: 11;\n    overflow: hidden;\n}\n\n.chat-dropdown > button {\n    display: block;\n    width: 100%;\n    padding: 10px 16px;\n    background: transparent;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n    transition: background 0.15s;\n}\n\n.chat-dropdown > button:hover {\n    background: #f5f5f5;\n}\n\n.chat-dropdown-confirm {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    font-size: 14px;\n}\n\n.chat-dropdown-confirm span {\n    color: #333;\n    white-space: nowrap;\n}\n\n.chat-dropdown-confirm button {\n    padding: 4px 10px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    cursor: pointer;\n    font-size: 13px;\n    background: #fff;\n    transition: background 0.15s;\n}\n\n.chat-dropdown-confirm button:first-of-type {\n    background: #dc3545;\n    color: #fff;\n    border-color: #dc3545;\n}\n\n.chat-dropdown-confirm button:first-of-type:hover {\n    background: #bb2d3b;\n}\n\n.chat-dropdown-confirm button:last-of-type:hover {\n    background: #f0f0f0;\n}\n\n/* Override per la navbar interna alla chat */\n.navbar_chat_mobile .nameHeader {\n    position: relative;\n}\n\n.navbar_chat_mobile .chat-menu-wrapper {\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n    margin-left: unset;\n}\n\n.navbar_chat_mobile .chat-dropdown {\n    position: absolute;\n    bottom: unset;\n    top: 36px;\n    right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
